const apiName = 'leverege.fotaApi';
const device = 'leverege.fotaApi.device';
const deviceGroup = 'leverege.fotaApi.deviceGroup';
const deviceType = 'leverege.fotaApi.deviceType';
const firmwareRelease = 'leverege.fotaApi.firmwareRelease';
const firmwareApplication = 'leverege.fotaApi.firmwareApplication';
const firmwareComponent = 'leverege.fotaApi.firmwareComponent';
const toCheckForLinkedAttributes = [deviceType, firmwareRelease, deviceGroup, firmwareApplication, firmwareComponent, device];
const updateable = [deviceType, firmwareRelease, deviceGroup, firmwareApplication, firmwareComponent, device];
const creatable = [deviceType, firmwareRelease, deviceGroup, firmwareApplication, firmwareComponent, device];
export default {
  apiName,
  device,
  deviceGroup,
  deviceType,
  firmwareRelease,
  firmwareApplication,
  firmwareComponent,
  toCheckForLinkedAttributes,
  updateable,
  creatable
};